import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, combineLatest } from "rxjs";
import { LoanData } from "../domain/models/loan.model";
import { map, take } from "rxjs/operators";
import { CustomerLoanStatus, RouteHelper, parseNumber, SsoAccountFacade, SsoAccountData, LoanHelper, AgreementSigningStatus } from "common";
import { LoanFacade } from "../domain/+state/loan.facade";

@Injectable({
  providedIn: "root",
})
export class LoanPendingGuard implements CanActivate {
  constructor(
    private router: Router,
    private loanFacade: LoanFacade,
    private ssoAccountFacade: SsoAccountFacade
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const accountId = parseNumber(RouteHelper.getParamValueByName(route, "accountId"));
    return combineLatest([
      this.ssoAccountFacade.getCurrentSsoAccount$(),
      this.loanFacade.getLoan$(accountId),
    ]).pipe(
      take(1),
      map(([currentSsoAccount, loan]) => this.validate(loan, currentSsoAccount))
    );
  }

  validate(loan: LoanData, currentSsoAccount: SsoAccountData): boolean {
    const loanState = LoanHelper.getLoanAgreementState(loan.id, currentSsoAccount);
    if (loanState?.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser) {
      this.router.navigate([`account/${loan.id}/setup/sign-agreement`]);
      return false;
    }
    return true;
  }
}

@Injectable({
  providedIn: "root",
})
export class LoanOpenGuard implements CanActivate {
  constructor(private router: Router, private loanFacade: LoanFacade) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const accountId = parseNumber(RouteHelper.getParamValueByName(route, "accountId"));
    return this.loanFacade.getLoan$(accountId).pipe(
      take(1),
      map((loan) => this.validate(loan))
    );
  }
  validate(loan: LoanData): boolean {
    if (loan.customerFacingStatus === CustomerLoanStatus.Open.valueOf()) return true;
    this.router.navigate(["home"]);
    return false;
  }
}
